import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`國泰世華銀行成立於民國 64 年，為國泰金控成員之一，目前全台營業據點達 165 家，是台灣營運據點數最多的民營銀行；海外布局部分，在大中華地區，已於大陸設立子行、於香港設有分行，東南亞市場方面，目前已於東協 10 國中的 9 國設立據點，為東南亞布局最廣的台資銀行。 此外，本行並設有國泰世華藝術中心，文化慈善基金會及金融圖書館等，為社會公益善盡社會責任。本行除提供海內、外客戶各項金融服務外，並與集團旗下國泰人壽、國泰產險及國泰證券等各子公司充分配合，發揮集團金流平台的角色，擴大金控綜效，以完整的產品線為客戶提供 one-stop-shopping（一站購足）全方位的金融理財服務。同時繼續拓展海外市場，進一步掌握金融市場大幅開放的契機，穩步朝「亞太地區最佳金融機構」的願景邁進。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      